"use client";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CacheKeys } from "../../constants/CacheKeys";
import { VsaTableColumnDefinition } from "../../constants/DataGridColumns";
import { useGetActivityFields } from "../../hooks/useActivities";
import { useGetLinkFields } from "../../hooks/useTools";
import { ApiEndpoints } from "../../models/ApiEndpoints";
import { Tool, ToolTypes } from "../../models/Tool";
import { mergeToolsFieldsWithAssociatedActivitiesFields } from "../../services/ToolService";
import { getToolColumnsFromColumnOrder } from "../../services/ViewService";
import { PaginatedList } from "../list/PaginatedList";

const ArchivedLinkList = () => {
  const { t } = useTranslation();

  const { data: viewDefinition, isLoading: viewDefinitionLoading } =
    useGetLinkFields();

  const {
    data: activityViewDefinition,
    isLoading: activityViewDefinitionLoading,
  } = useGetActivityFields();

  const columns = useMemo<VsaTableColumnDefinition<Tool>[]>(() => {
    if (
      viewDefinitionLoading ||
      !viewDefinition ||
      !activityViewDefinition ||
      activityViewDefinitionLoading
    ) {
      return [];
    }

    return getToolColumnsFromColumnOrder(
      viewDefinition.standardFields,
      viewDefinition.fields,
      activityViewDefinition.fields,
      viewDefinition.publishedFieldOrder,
      ToolTypes.Link,
      false
    );
  }, [
    viewDefinition,
    viewDefinitionLoading,
    activityViewDefinition,
    activityViewDefinitionLoading,
  ]);

  return (
    <PaginatedList<Tool>
      apiEndpoint={ApiEndpoints.ToolLinksCurrentArchived}
      columns={columns}
      defaultSortAscending={false}
      defaultSortColumnName={"modified"}
      searchPlaceholder={t("searchTool")}
      postQueryTransformation={mergeToolsFieldsWithAssociatedActivitiesFields}
      cacheKey={CacheKeys.Link.LinkArchivedList}
      filtersEndpoint={ApiEndpoints.ToolLinkFilters}
      storageKey="links:archived"
      libraryFilterScope={{ listType: "link" }}
    />
  );
};

export default ArchivedLinkList;
